module.exports = __webpack_public_path__ + "static/scale-model-of-shadow-lake-nature-preserve-in-renton-washington-06e1acfa74894c0b6ec3ed9c50520466.png";